import {Component, Input} from '@angular/core';

@Component({
  selector: 'app-icon-entrar-login',
  imports: [],
  templateUrl: './icon-entrar-login.component.html',
  standalone: true,
  styleUrl: './icon-entrar-login.component.css'
})
export class IconEntrarLogin {
  @Input() color: string = '#171717';
  @Input() size: string = '24px';
}
